import styled from "styled-components";

export const ImageStyled = styled.img`
  width: 145px;
  height: 34.05px;
`;

export const ContainerProfileStyled = styled.div`
  display: flex;
`;
